const EnumRecordStates = {
    Current: 1,
    Draft: 6,
    Template: 7,
    Pending: 8,
    Future: 9,
    Past: 10,
    Legacy: 11
};

export default EnumRecordStates;